<template>
  <div>
    <div class="pb-3">
      <div>
        <v-img class="mx-auto" width="150px" :src="detaildata.image_link"></v-img>
      </div>
      <div class="px-5">
        <v-layout row wrap class="ma-0">
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">ID</div>
            <div>{{ detaildata.product_id }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Title</div>
            <div>{{ detaildata.title }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Price</div>
            <div>{{ detaildata.price }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Sale price</div>
            <div>{{ detaildata.sale_price }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Category</div>
            <div>{{ detaildata.category }}</div>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <div class="caption grey--text">Description</div>
            <div>{{ detaildata.description }}</div>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <div class="caption grey--text">Short Description</div>
            <div>{{ detaildata.short_description }}</div>
          </v-flex>
          <!-- <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Image link</div>
            <div>{{ detaildata.product_id }}</div>
          </v-flex> -->
          <v-flex xs12 class="mb-2">
            <div class="caption grey--text">Link</div>
            <div>
              <a :href="detaildata.links">
                {{ detaildata.links }}
              </a>
            </div>
          </v-flex>

          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Effective date</div>
            <div>{{ detaildata.effective_date | DateFormat('DD/MM/YYYY HH:mm') }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Availability</div>
            <div>{{ detaildata.availability }}</div>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <div class="caption grey--text">Product type</div>
            <div>
              <v-chip small v-for="(type, k) in productType" :key="k">{{ type }}</v-chip>
            </div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Brand</div>
            <div>{{ detaildata.brand }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Condition</div>
            <div>{{ detaildata.condition }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Adult</div>
            <div>{{ detaildata.adult }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Color</div>
            <div>{{ detaildata.color }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Gender</div>
            <div>{{ detaildata.gender }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Size</div>
            <div>{{ detaildata.size ? detaildata.size : '-' }}</div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <div class="caption grey--text">Weight</div>
            <div>{{ detaildata.weight }}</div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detaildata'],
  data() {
    return {
      items: [
        'ID',
        'Title',
        'Category',
        'Description',
        'ShortDescription',
        'Image link',
        'Link',
        'Price',
        'Sale price',
        'Sale price effective date',
        'Availability',
        'Product type',
        'Brand',
        'Condition ',
        'Adult',
        'Color',
        'Gender',
        'Size',
        'Weight'
      ]
    }
  },
  computed: {
    productType() {
      var result = this.detaildata.product_type.replace(/&gt;/g, ' > ')

      return result.split('|')
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ProductAndBranch/ProductDetail.vue